import {en, type I18nKey} from "./en";
import {ro} from "./ro";

export type Lang = "ro" | "en";

const dict: Record<Lang, Record<I18nKey, string>> = {en, ro};

export function translate(lang: Lang, key: I18nKey): string {
  return dict[lang]?.[key] ?? en[key] ?? key;
}

export {en, ro, type I18nKey};
